<script>
    export let dynamic_scale;
    export let static_scale;
    export let all_data;
    export let gender_data;
    export let age_data;
    export let region;

    import GraphPointsGroup from './GraphPointsGroup.svelte';
</script>

<GraphPointsGroup
    {dynamic_scale}
    {static_scale}
    horizontal={true}
    data={all_data}
    {region}
/>
<GraphPointsGroup
    {dynamic_scale}
    {static_scale}
    horizontal={true}
    data={gender_data}
    {region}
/>
<GraphPointsGroup
    {dynamic_scale}
    {static_scale}
    horizontal={true}
    data={age_data}
    {region}
/>